export const validateEmail = (email) => {
  const atSymbolCount = (email.match(/@/g) || []).length;
  return atSymbolCount === 1;
};
